import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { Blog } from '@models/blog';
import { FirebaseRTDBService } from './firebasert.abstract.service';

@Injectable({
  providedIn: 'root'
})
export class BlogService extends FirebaseRTDBService<Blog> {

  protected basePath = 'blog';
  // private blogData: Blog[] = JSON.parse(JSON.stringify(blogDataJson));

  constructor(firestore: Firestore) {
    super(firestore);
  }

  // Add your blog-related methods here
  createBlog(blog: Blog): Promise<Blog | any | Error> {
    return this.create(blog);
  }

  // Retrieve all blog posts
  async getAllBlogs(): Promise<Blog[]> {
    const blogs = await this.getCollection$();
    // Blog Listing Logic the latest published blog rank upper and draft blog goes to down side of the list
    return blogs.sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
  }

  // Retrieve a blog post by ID
  getBlogById(id: string): Promise<Blog | any | false> {
    return this.getDocument(id);
  }

  // Get only published blog posts
  // getAllPublishedBlogs(): Promise<Blog[]> {
  //   return this.getCollection$((collectionRef) => query(collectionRef, where('status', '==', 'publish')));
  // }   // Function Does not used and also its giving error because of this.getcollection return promise

  // Update a blog post
  updateBlog(blog: Blog): Promise<Blog | any | Error> {
    return this.update(blog, blog.uid);
  }

  // Delete a blog post
  deleteBlog(id: string): Promise<string> {
    return this.delete(id);
  }

  // updateBlog(id: string, blog: Partial<Blog>): Promise<Blog | any | Error> {
  //   return this.update(blog, id);
  // }

  // deleteBlog(id: string): Promise<void> {
  //   return this.delete(id); // Uses inherited delete method
  // }

  // getBlogByIdFromJson(id: number|string) {
  //   // find blog by id in the JSON data by id string or number

  //   // return this.blogData.find(blog => blog.id == id);
  // }

}
